module.exports = __webpack_public_path__ + "img/4-2.9bafdc8c.svg";